export function collectTextNodes(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: (n) =>
      n.nodeValue && n.parentElement && !n.parentElement.closest('.de-skip')
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT,
  });
  const out = [];
  while (walker.nextNode()) out.push(walker.currentNode);
  return out;
}
